// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c3-2";
export var aiChatCartContainerExit = "_c3-4";
export var aiChatContainerLarge = "_c3-0";
export var aiChatContainerSmall = "_c3-1";
export var aiChatIcon = "_c3-6";
export var slideInFromRight = "_c3-3";
export var slideOutToRight = "_c3-5";